import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function IdentitasKoperasi() {
  const { id, npp } = useParams();
  const history = useHistory();
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  const [newData, setNewData] = useState([{
    name: "",
    location: "",
    email: "",
  }]);
  const [dataKopkar, setDataKopkar] = useState([]);


  // CONTROLLER

  const fetchDataKopkar = async () => {
    setIsLoading(true);
    await baseAPI
      .get(`/v1/kopkar`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.kopkar;
        setDataKopkar(data[0]);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const updateKoperasi = async () => {

    Swal.fire({
      title: 'Do you want to update koperasi identity?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Update',
      denyButtonText: `Don't update`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('update_data', JSON.stringify(dataKopkar));

        baseAPI
          .put(`/v1/kopkar`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Koperasi identity has been updated.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil update ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Failed update the data.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchDataKopkar();
          })
      } else if (result.isDenied) {
        Swal.fire('Data is not updated', '', 'info')
      }
    });

  }

  useEffect(() => {
    setIsLoading(true);
    if (user.role === ADMIN) {
      fetchDataKopkar();
    }
  }, [token]);
  

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Setting</Link> /{' '}
              <Link to='/setting/identitaskoperasi' style={{ color: '#333' }}>Identitas Koperasi</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Data Koperasi</b></p>
              </div>

              {/* nama koperasi */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama Koperasi
                </label>
                <input
                  defaultValue={dataKopkar.name}
                  placeholder='Name untuk koperasi'
                  className="form-control"
                  onChange={e => setDataKopkar({...dataKopkar, name: e.target.value})}
                />
              </div>

              {/* alamat koperasi */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Alamat
                </label>
                <input
                  defaultValue={dataKopkar.location}
                  placeholder='Alamat lengkap koperasi'
                  className="form-control"
                  onChange={e => setDataKopkar({...dataKopkar, location: e.target.value})}
                />
              </div>

              {/* no hp koperasi */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Email
                </label>
                <input
                  defaultValue={dataKopkar.email}
                  placeholder='Email koperasi'
                  className="form-control"
                  onChange={e => setDataKopkar({...dataKopkar, email: e.target.value})}
                />
              </div>

              <div className='col-md-12'>
                <button
                  disabled={dataKopkar.name !== "" && dataKopkar.email !== "" && dataKopkar.location !== "" ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => updateKoperasi()}
                >
                  Save
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default IdentitasKoperasi;